var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_13932_75372)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_13932_75372",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_13932_75372",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_13932_75372",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFHElEQVR4nO2bv28dRRDHj18JBAQp+NnwS2lwkeDMnB0oSAUVBRQRBXUkEiEFFEBQgFECkmki/gikIAONkSyZ2/EJCkSBkIgQDQIloYiRRZOEPHvXZGGeHeM7vxdyd/tuznfzlbaI7czufT87e7tzd1GkUqlUKlVNcoReG96wBwqEmjVhFAjJQ1AgJG+8AiF5sxUIyRusQEjeVAVC8kYqkAaY5xSIvGFOgcib5BSIvDFOgcib4RrQtHRC8hAUCMkbr0BI3mwFQvIGKxCSN7WVQKJtLtfU627swLp63Y0dWFevu7ED6+p1V73Jda1FCgTFISgQkjdegZC82QqE5A1WICRvqgIheSMVSAPMcwpE3jCnQORNcgpE3hinQOTNcA1oWjoheQgKhOSNVyAkb7YCIXmDFQjJm6pASN5IBdIA85wCkTfMKRB5k5wCkTfGKRB5M1wDmpZOSB7CtgBSNm7UECkQUiCiM0UzpKQUCLbjHtLVFikQFIegQEjeeAVC8mYrEJI3WIGQvKkKhOSNVCAtbd5MPtDIc0jZuJGA/LcH7nAE71sDvapALOFlRzjt0327RzLYtgNxJn7REp4LnSnWwAVH8Fz4AbcUiPfRTY7wg+sYetESnF6h+LBNMPbfPHmf/x5u87Owy9P4Izbdf8AaPGYJZq3BS4Nj4FVH+JGfOXRLsIG3EYhPD95uCT4dNrPtAh7183vvvOF4CdxjDRwflmmW4BOfHrw1yOBDp3JTmyVctganfDp2VxXQfP+wBtyA+DNBMqUbMGDREj5d2axrnhk8MbAvgyerB2+AYW6UzcBPPoGHg5CIomg1wZcGZch6lvztkv3PKxAakhkGl3oJPh4MBsGhYTA2Z6Ofm7i7dCfiM5hGtUzhcshlalBm9P9t8ORWSPChAqEt2TE1ahj8c/49b31zv7vi0/jBUp21MjsMXKiymyoCY2ObbeD3bIbC2wqE1s1YwKN1wbgmS/hmZmIY/IUPp4U7LTsLy8aNAssamMgZdrHIoS8EjI3D41qda+PvVxIc7x4QwndyS8XpumH8Nxb4Mvd/Xu0eEAOfZ2YlxYclYPTHQvB65cmx3YE4wjM58yYkYLBsEj+VvV74oTYgTW0+hXslYLB68xOP5TLkfOGBtA7IzNiOECdwS7C6msQvF4nDpfsc0CtFx9I+ILOwSwIGy8/t2ZmNg8tR14H00slH61ymNsvP770/GwuXCgeRNtAFbvykTwIGi/vOjedM4SCtA2LwmAQMljXwSiYm4WeFg7QOCMGsBAwWA8jFfatwkBZmyCUuY9QNg4uZ+dKJTWPsPBC3ZvLxOmGwLMGR3MQ466eimxUI9dfuc1wSrwsGb3cZQJDn69JLjBtdm64DBssafC8Xv+e/hocUCP3/49XgMCh+xhq02ckAH5cO2ICZ7OtqZU/gw9R/w5Hwj1wfi5Xe++0MDBM2M9YLiT9n+8CrzsALlQJLG+XqagZPBF6mlgb0capy8C5liOMXozftvkrtpgjetYQrA+J/oa+SUgkwBOf5hYRhh8fhhz44smVruxnG3J6dUQhJz1wnlTGEl/kZuDX4Gj/p43tC/1OEmbEdXLW1CzDJtSl+iTp/As/eM/BU0M8R2i5n4FlH8Gt4oLDIHwNJX9+2lF97kjc97MObgveiHp8zRvZJW5fk0327LeEbjuC34iDwLB80S5/AVdF1tfzV+BP8hmP/SyuD37HhlvAv3kFZgj8d4Y9cTucSOldtSxUK/+3oH5hqRYn0FZKnAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.33566f62d9cfdd59cf5decc1bc899ecc.svg";
export { ForwardRef as ReactComponent };